var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.299805C9.6483 0.299805 12.2002 2.8517 12.2002 6C12.2002 9.1483 9.6483 11.7002 6.5 11.7002C3.3517 11.7002 0.799805 9.1483 0.799805 6C0.799805 2.8517 3.3517 0.299805 6.5 0.299805ZM6.5 1.3877C3.95298 1.3877 1.8877 3.45298 1.8877 6C1.8877 8.54702 3.95298 10.6123 6.5 10.6123C9.04702 10.6123 11.1123 8.54702 11.1123 6C11.1123 3.45298 9.04702 1.3877 6.5 1.3877ZM6.49805 2.70215C6.62862 2.69847 6.76389 2.73234 6.86816 2.8125C6.97479 2.89447 7.04395 3.02108 7.04395 3.1875V5.9248H9.78125C10.2057 5.9248 10.4424 6.18572 10.4424 6.46875C10.4424 6.75178 10.2057 7.0127 9.78125 7.0127H5.95605V3.1875C5.95605 3.03224 6.02687 2.91012 6.13086 2.82812C6.23329 2.74744 6.36735 2.70587 6.49805 2.70215Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.34110cce7f837f5370dcd95994bbea14.svg";
export { ForwardRef as ReactComponent };